import { useState, useEffect } from "react";
import './App.css';
import { Route, Routes } from 'react-router-dom';
import * as dataManager  from './fetchData/DataManager'
import BodyComponent from "./components/BodyComponent";
import BodyComponentSection from "./components/BodyComponentSection";
import BodyComponentDetails from "./components/BodyComponentDetails";
import configData from './config.json'


function App() {

  const [activeCategory, setActiveCategory] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [activeVideo, setActiveVideo] = useState({});

  const [mediaLoaded, setMediaLoaded] = useState(false);

  var videoFetchStarted = false;
  var videosLoaded = false;

  useEffect(() => {

    if (!videoFetchStarted && !videosLoaded) {

      videoFetchStarted = true;
      const fetchVideos = async () => {

        var playlists = JSON.parse(localStorage.getItem(configData.LOCALSTORAGE.PLAYLISTS));
        if(playlists === null) {
          const playlistsLoadingFinished = await dataManager.getAllPlaylists();
        }
        else {
          var playlistsTimestamp = JSON.parse(localStorage.getItem(configData.LOCALSTORAGE.PLAYLISTS_TIMESTAMP));

          var diff = Date.now() - playlistsTimestamp;
          var sec = Math.floor((diff/1000));

          if(sec > 60) {
            const playlistsLoadingFinished = await dataManager.getAllPlaylists();
          }
        }

        var playlists = JSON.parse(localStorage.getItem(configData.LOCALSTORAGE.PLAYLISTS));
        const videosLoadingFinished = await dataManager.addVideosinPLaylists(playlists, setActiveCategory, setActiveVideo, setCategoryList);
        
        videoFetchStarted = false;
        videosLoaded = true;
        setMediaLoaded(true);
      }

      fetchVideos()
        .catch(console.error);
      
    }
  }, []);

  useEffect(() => {
    if (activeCategory !== undefined) {
    }
  }, [activeCategory]);

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<BodyComponent setActiveCategory={setActiveCategory}
            setCategoryList={setCategoryList}
            categoryList={categoryList}
            setActiveVideo={setActiveVideo}
            activeVideo={activeVideo}
            shouldLoad={mediaLoaded}
            activeCategory={activeCategory}
          />}
        />
        <Route
          path="/:playlist"
          element={<BodyComponentSection
            category={activeCategory}
            categoryList={categoryList}
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
            setActiveVideo={setActiveVideo}
            setCategoryList={setCategoryList}
            shouldLoad={mediaLoaded}
          />}
        />
        <Route
          path="/video/:cat/:id/:urlName"
          element={<BodyComponentDetails category={activeCategory}
            categoryList={categoryList}
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
            setActiveVideo={setActiveVideo}
            activeVideo={activeVideo}
            setCategoryList={setCategoryList}
            shouldLoad={mediaLoaded}
          />}
        />
      </Routes>
    </>
  );
}

export default App;
